import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'; 
import { getTicketPublic } from '../api';

const useTicketPublic = () => {
  const { codigo } = useParams(); 
  const [ticketData, setTicketData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTicket = async () => {
    if (!codigo) {
      setError('Código de ticket no proporcionado');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      /* console.log('DEBUG - Fetching ticket codigo:', codigo); */
      
      const response = await getTicketPublic(codigo);
      
      if (response.status === 'success') {
        setTicketData(response.data);
      } else {
        setError(response.message || 'Error al cargar ticket');
      }
    } catch (err) {
      console.error('Error fetching ticket:', err);
      setError('Error al cargar el ticket');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTicket();
  }, [codigo]);

  return {
    ticketData,
    setTicketData,
    setLoading,
    loading,
    error,
    refetch: fetchTicket 
  };
};

export default useTicketPublic;